export default __webpack_public_path__ + "static/media/signUpLoader.2b3cf16a.gif";